import { useCallback, useEffect, useState } from 'react';
import { getSupportTickets, type SupportStatus, type SupportTicket } from '../../api';
import { getApiErrorMessage } from '../../utils/apiError';
import SupportTicketList from './SupportTicketList';
import './SupportPage.css';

const FILTERS: { value: SupportStatus | ''; label: string }[] = [
  { value: 'open', label: 'Ждут ответа' },
  { value: 'answered', label: 'Есть ответ' },
  { value: 'resolved', label: 'Решённые' },
  { value: '', label: 'Все' },
];

const SupportInboxPage = () => {
  const [status, setStatus] = useState<SupportStatus | ''>('open');
  const [tickets, setTickets] = useState<SupportTicket[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setTickets(await getSupportTickets(status || undefined));
    } catch (err) {
      setError(getApiErrorMessage(err, 'Не удалось загрузить обращения'));
    } finally {
      setLoading(false);
    }
  }, [status]);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="support-page">
      <div className="support-container">
        <header className="support-header">
          <img src="/support.png" alt="" className="support-header-icon" />
          <h2>Входящие обращения</h2>
        </header>

        <div className="support-filters" role="group" aria-label="Фильтр по статусу">
          {FILTERS.map((filter) => (
            <button
              key={filter.label}
              type="button"
              className="support-filter"
              aria-pressed={status === filter.value}
              onClick={() => setStatus(filter.value)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="support-state" role="status">
            Загрузка…
          </div>
        ) : error ? (
          <div className="support-state support-state--error" role="alert">
            {error}
          </div>
        ) : tickets.length === 0 ? (
          <div className="support-state ui-panel ui-panel-tight">
            Здесь пусто
          </div>
        ) : (
          <SupportTicketList tickets={tickets} showAuthor />
        )}
      </div>
    </div>
  );
};

export default SupportInboxPage;
